// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lowRiskCustomMarker {
  background-position: center;
  background-color: rgba(170, 170, 238, 0.555);
  border: 2px solid rgba(170, 170, 238, 0.555);
  border-radius: 50%;
  color: #6A37C3;
}

.highRiskCustomMarker {
  background-position: center;
  background-color: rgb(244, 67, 54, 0.3);
  border: 2px solid rgb(244, 67, 54, 0.3);
  border-radius: 50%;
  color: #F44336;
}

.lowRiskCustomMarker div, .highRiskCustomMarker div {
  margin-top: 30%;
  text-align: center;
  font: 12px 'Nunito Sans', sans-serif;
  font-weight: 600;
}

.lowRiskCustomMarker span, .highRiskCustomMarker span {
  text-align: center;
}

/* tooltip styles */
.tooltip-country-name {
  font-style: normal;
}

.tooltip-high-risk-country-name {
  color: #df2e21;
  font-family: "Nunito Sans", sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: normal;
}

.tooltip-domain {
  display: flex;
  flex-direction: row;
  align-self: flex-start;
  justify-content: space-between;
  font-weight: 600;
  letter-spacing: 0.3px;
  font-size: 10px;
}

.tooltip-domain-count {
  align-self: flex-end;
  margin-left: 8px;
}

/* countries contacted / domain list overlay */
.overlay {
  position: relative;
  height: 480px;
  top: 10px;
  width: 30%;
  margin-left: 69%;
  min-width: 200px;
}

.overlay-high-risk-country-name {
  color: #df2e21;
}
`, "",{"version":3,"sources":["webpack://./src/components/Applications/css/map.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,4CAA4C;EAC5C,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,uCAAuC;EACvC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".lowRiskCustomMarker {\n  background-position: center;\n  background-color: rgba(170, 170, 238, 0.555);\n  border: 2px solid rgba(170, 170, 238, 0.555);\n  border-radius: 50%;\n  color: #6A37C3;\n}\n\n.highRiskCustomMarker {\n  background-position: center;\n  background-color: rgb(244, 67, 54, 0.3);\n  border: 2px solid rgb(244, 67, 54, 0.3);\n  border-radius: 50%;\n  color: #F44336;\n}\n\n.lowRiskCustomMarker div, .highRiskCustomMarker div {\n  margin-top: 30%;\n  text-align: center;\n  font: 12px 'Nunito Sans', sans-serif;\n  font-weight: 600;\n}\n\n.lowRiskCustomMarker span, .highRiskCustomMarker span {\n  text-align: center;\n}\n\n/* tooltip styles */\n.tooltip-country-name {\n  font-style: normal;\n}\n\n.tooltip-high-risk-country-name {\n  color: #df2e21;\n  font-family: \"Nunito Sans\", sans-serif;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.tooltip-domain {\n  display: flex;\n  flex-direction: row;\n  align-self: flex-start;\n  justify-content: space-between;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  font-size: 10px;\n}\n\n.tooltip-domain-count {\n  align-self: flex-end;\n  margin-left: 8px;\n}\n\n/* countries contacted / domain list overlay */\n.overlay {\n  position: relative;\n  height: 480px;\n  top: 10px;\n  width: 30%;\n  margin-left: 69%;\n  min-width: 200px;\n}\n\n.overlay-high-risk-country-name {\n  color: #df2e21;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
